import React from "react";
import BreadcrumbItem from "./BreadcrumbItem";
import BreadcrumbIcon from "./BreadcrumbIcon";

const getBreadcrumbsByTemplate = (templateName, settings, isMobile) => {
    const { collection, section, routes, page, product, blog, article, request } = settings || {};
    const backToCategory = section?.use_back_to_category_products;

    switch (templateName) {
        case "product":
            return (
                <>
                    {!backToCategory && <>
                        <BreadcrumbItem
                            title={collection?.title || "Products"}
                            url={collection?.url || section?.default_shop_url || routes?.all_products_url || "/collections/all"}
                            position={2}
                            settings={settings}
                            isMobile={isMobile}
                            classes=""
                        />
                        <BreadcrumbIcon settings={settings} isMobile={isMobile} icon={section?.icon || "icon-caret-right-thin"} />
                        <BreadcrumbItem 
                            title={product?.title || "Product"} 
                            url={page?.url || window.location.pathname} 
                            position={3} 
                            isActive 
                            settings={settings}
                            isMobile={isMobile}
                            classes=""
                        />
                    </>}
                    {backToCategory && collection?.url &&
                        <>
                            <BreadcrumbIcon settings={settings} isMobile={isMobile} icon={'icon-arrow-left'} />
                            <BreadcrumbItem
                                classes={`text-[#7A7A7A] ml-[14px] text-[10px] h6`}
                                title={'Back to category'}
                                url={collection?.url}
                                position={2}
                                isActive
                                settings={settings}
                                isMobile={isMobile}
                            />
                        </>
                    }
                </>
            );
        case "cart":
            return <BreadcrumbItem title="Cart" url={routes?.cart_url || "/cart"} position={2} isActive settings={settings} isMobile={isMobile} classes="" />;
        case "collection":
            return <BreadcrumbItem title={collection?.title || "Collection"} url={collection?.url || window.location.pathname} position={2} isActive settings={settings} isMobile={isMobile} classes="" />;
        case "blog":
            return <BreadcrumbItem title={blog?.title || "Blog"} url={blog?.url || window.location.pathname} position={2} isActive settings={settings} isMobile={isMobile} classes="" />;
        case "article":
            return (
                <>
                    <BreadcrumbItem title={blog?.title || "Blog"} url={blog?.url || "/blogs"} position={2} settings={settings} isMobile={isMobile} classes="" />
                    <BreadcrumbIcon settings={settings} isMobile={isMobile} icon={section?.icon || "icon-caret-right-thin"} />
                    <BreadcrumbItem title={article?.title || "Article"} url={page?.url || window.location.pathname} position={3} isActive settings={settings} isMobile={isMobile} classes="" />
                </>
            );
        case "search":
            return <BreadcrumbItem title="Shop All" url={request?.path || window.location.pathname} position={2} isActive settings={settings} isMobile={isMobile} classes="" />;
        case "account":
            const currentLink = window.location.pathname + window.location.search;
            const matchedLink = document.querySelector(`#accountMenu [href="${currentLink}"]`);
            const matchedLinkTitle = matchedLink?.getAttribute("data-link-title") || "";

            return (
                <>
                    <BreadcrumbItem title={page?.title || "Account"} url={window.location.pathname} position={2} settings={settings} isMobile={isMobile} classes="" />
                    {matchedLink && (
                        <>
                            <BreadcrumbIcon settings={settings} isMobile={isMobile} icon={section?.icon || "icon-caret-right-thin"} />
                            <BreadcrumbItem title={matchedLinkTitle} url={currentLink} position={3} isActive settings={settings} isMobile={isMobile} classes="" />
                        </>
                    )}
                </>
            );
        default:
            return <BreadcrumbItem title={page?.title || "Page"} url={request?.path || window.location.pathname} position={2} isActive settings={settings} isMobile={isMobile} classes="" />;
    }
};

export default getBreadcrumbsByTemplate;
